<template>
  <div class="home_wrap">
    <div
      ref="homeScroll"
      class="home-scroll"
    >
      <header class="home-top">
        <img
          class="logo"
          src="../images/ban6/logo.png"
          :alt="$t('homeDesign.home')"
        >
        <button
          type="button"
          class="service"
          :aria-label="$t('notice.message')"
          @click="$router.push('/notice')"
        >
          <img
            src="../images/ban6/rank.png"
            alt=""
          >
        </button>
      </header>

      <van-swipe
        v-if="banner && banner.length"
        class="hero-swipe"
        :autoplay="3000"
        lazy-render
      >
        <van-swipe-item
          v-for="(item, index) in banner"
          :key="index"
        >
          <img
            :src="item[lang]"
            alt=""
          >
        </van-swipe-item>
      </van-swipe>

      <div
        v-if="notifyStr"
        class="notice-card"
      >
        <img
          class="notice-icon"
          src="../images/ban6/notice.png"
          alt=""
        >
        <div class="notice-text">
          <marquee
            scrollamount="3"
            behavior="scroll"
          >
            {{ notifyStr }}
          </marquee>
        </div>
        <router-link
          class="more-link"
          to="/notice"
        >
          {{ $t('homeDesign.more') }}
        </router-link>
      </div>

      <div class="quick-actions">
        <button
          v-for="item in quickActions"
          :key="item.name"
          type="button"
          class="quick-action"
          @click="goQuickAction(item)"
        >
          <img
            :src="item.icon"
            alt=""
          >
          <span class="quick-action-label">{{ $t(item.labelKey) }}</span>
        </button>
      </div>

      <section
        v-if="popularCities.length"
        class="popular-city-card"
      >
        <h2 class="popular-city-label">
          {{ $t('sky.popularCity') }}:
        </h2>
        <div class="popular-city-grid">
          <router-link
            v-for="city in popularCities.slice(0, 10)"
            :key="city.id"
            class="popular-city-item"
            to="/vchoose"
            :title="city.name"
          >
            {{ city.name }}
          </router-link>
        </div>
        <router-link
          class="popular-city-more"
          to="/vchoose"
        >
          {{ $t('sky.otherRegion') }}
        </router-link>
      </section>

      <section class="girls-list-wrap">
        <div class="section-title">
          <h2>{{ $t('sky.tuijian') }}</h2>
          <router-link
            class="more-link"
            to="/vchoose"
          >
            {{ $t('homeDesign.more') }}
          </router-link>
        </div>
        <van-list
          v-model="girlsLoading"
          :finished="girlsFinished"
          :error.sync="girlsError"
          :error-text="$t('homeDesign.loadFailed')"
          :immediate-check="false"
          :offset="100"
          :loading-text="$t('pro2.loading')"
          @load="loadGirls"
        >
          <div class="girls-grid">
            <router-link
              v-for="item in girls"
              :key="item.id"
              class="girl-card"
              :to="'/vprofile/' + item.id"
            >
              <div class="girl-media">
                <img
                  class="girl-photo"
                  :src="formatAssetUrl(item.pic)"
                  :alt="item.name"
                  loading="lazy"
                >
                <img
                  class="card-mark"
                  src="../images/ban6/lives.gif"
                  alt=""
                >
                <span
                  v-if="Number(item.ishigh) === 1"
                  class="corner-ribbon"
                ><i>{{ $t('sky.gaoduan') }}</i></span>
                <div class="girl-info">
                  <div class="girl-topline">
                    <h3>{{ item.name }}</h3>
                    <span
                      v-if="item.addr"
                      class="location-chip"
                      :title="item.addr"
                    >{{ item.addr }}</span>
                  </div>
                  <div class="girl-metrics">
                    <div
                      v-if="item.zan !== undefined && item.zan !== null && item.zan !== ''"
                      class="view-row"
                      :aria-label="$t('homeDesign.likes') + ': ' + item.zan"
                    >
                      <img
                        src="../images/ban6/icon_views.png"
                        alt=""
                      >
                      <span>{{ item.zan }}</span>
                    </div>
                    <div
                      v-if="hasGirlScore(item)"
                      class="like-row girl-score"
                      :aria-label="$t('videoPage.score', { score: formatGirlScore(item.score) })"
                    >
                      <img
                        src="../images/ban6/icon_love.png"
                        alt=""
                      >
                      <span>{{ formatGirlScore(item.score) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <p
            v-if="girlsFinished && !girls.length"
            class="empty-list"
          >
            {{ $t('homeDesign.empty') }}
          </p>
        </van-list>
      </section>
    </div>

    <van-dialog
      v-model="show_tc"
      width="90%"
      :confirm-button-text="$t('utils.confirm')"
    >
      <img
        class="dialog-img"
        src="../images/index/date-popup-banner.png"
        alt=""
      >
      <div
        class="popup"
        v-html="tc_content"
      />
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { formatAssetUrl } from "../../utils/assets";
import {
	Swipe,
	SwipeItem,
	Icon,
	Dialog,
	List,
} from "vant";

Vue.use(Icon).use(Dialog).use(List);

export default {
	name: "Index",
	components: {
		VanSwipe: Swipe,
		VanSwipeItem: SwipeItem,
	},
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			loading: false,
			randomNumber: 0,
			data: {
				item1: { show: true },
				item2: { show: true },
				item3: { show: true },
			},
			app: {},
			islogin: false,
			isapp: false,
			show_tc: false,
			tc_content: "",
			vip: null,
			girls: [],
			girlsPage: 1,
			girlsLoading: false,
			girlsError: false,
			girlsFinished: false,
			girlsRequestLock: false,
			girlsLoadedPages: {},
			banner: null,
			items: null,
			cashes: null,
			coindatas: null,
			quickActions: [
				{ name: "events", path: "/loading", icon: require("../images/ban6/ico_vote.png"), labelKey: "homeDesign.events" },
				{ name: "news", path: "/about/33", icon: require("../images/ban6/icon_activities.png"), labelKey: "homeDesign.latestNews" },
				{ name: "video", path: "/vindex", icon: require("../images/ban6/ico_video.png"), labelKey: "homeDesign.video" },
				{ name: "dating", path: "/vchoose", icon: require("../images/ban6/ico_vip.png"), labelKey: "homeDesign.dating" },
			],
			popularCities: [],
			notifyStr: "",
		};
	},
	created() {
		this.$parent.footer("home");
	},
	mounted() {
		this.islogin = localStorage.getItem("token") != null;
		if (!this.islogin) {
			this.$router.push("/login");
		}

		this.start();
		this.$nextTick(() => {
			this.loadGirls();
		});

		if (this.$router.history.current.query.agent) {
			localStorage.setItem("agent", this.$router.history.current.query.agent);
		}
		if (this.$router.history.current.query.isapp) {
			localStorage.setItem("isapp", "true");
		}
		this.isapp = localStorage.getItem("isapp") != null;
	},
	methods: {
		formatAssetUrl,
		hasGirlScore(item) {
			var score = Number(item && item.score);

			return isFinite(score) && score > 0;
		},
		formatGirlScore(value) {
			var score = Number(value);

			return isFinite(score) && score > 0 ? (Math.round(score * 10) / 10).toFixed(1) : "--";
		},
		getcoinsdata() {
			Fetch("/user/getcoinsdata").then(r => {
				this.coindatas = JSON.parse(r.data);
			});
		},
		download() {
			var downloadurl = document.createElement("A");
			downloadurl.href = this.app.app_link;
			downloadurl.target = "blank";
			downloadurl.click();
		},
		goQuickAction(item) {
			this.$router.push(item.path);
		},
		start() {
			Fetch("/index/int").then(r => {
				this.data = r.data;
				this.vip = r.data.vip;
				this.banner = r.data.banner;
				this.notifyStr = r.data.notice;
				this.popularCities = Array.isArray(r.data.girls_classes) ? r.data.girls_classes : [];
				this.cashes = r.data.cashes;
				this.items = r.data.items;
				this.randomNumber = Math.floor(Math.random() * (7800 - 6877 + 1)) + 6877;
				this.loading = true;

				if (r.data.popup.show == 1) {
					this.tc_content = r.data.popup.content;
					if (localStorage.getItem("tc") != this.tc_content) {
						localStorage.setItem("tc", this.tc_content);
						this.show_tc = true;
					}
				}
			});

			Fetch("/index/webconfig").then(r => {
				this.app = r.data;
			});
		},
		loadGirls() {
			if (this.girlsRequestLock || this.girlsFinished) {
				this.girlsLoading = false;
				return;
			}
			if (this.girlsLoadedPages[this.girlsPage]) {
				this.girlsLoading = false;
				return;
			}

			this.girlsRequestLock = true;
			this.girlsLoading = true;
			this.girlsError = false;
			var currentPage = this.girlsPage;
			this.$set(this.girlsLoadedPages, currentPage, true);

			Fetch("/index/girls", {
				page: currentPage,
			}).then(r => {
				var data = r.data || {};
				var list = data.list || [];

				for (var i = 0; i < list.length; i++) {
					list[i].keys = list[i].keystr ? list[i].keystr.split("|") : [];
				}

				var existsMap = {};
				for (var j = 0; j < this.girls.length; j++) {
					existsMap[this.girls[j].id] = true;
				}

				var newList = list.filter(item => {
					if (!item.id || existsMap[item.id]) return false;
					existsMap[item.id] = true;
					return true;
				});

				if (newList.length > 0) {
					this.girls = this.girls.concat(newList);
				}

				this.girlsPage++;
				this.girlsFinished = !data.has_more || list.length === 0;
				this.girlsLoading = false;
				this.girlsRequestLock = false;
			}).catch(() => {
				this.$delete(this.girlsLoadedPages, currentPage);
				this.girlsError = true;
				this.girlsLoading = false;
				this.girlsRequestLock = false;
			});
		},

	},
};
</script>

<style lang="less" scoped>
.home_wrap {
  --accent: #f3c99e;
  --text: #eab98d;
  --muted: #b28d6c;
  --line: #75654f;
  width: 100%;
  min-height: 100vh;
  background: #201c1d;
  color: var(--text);
}
.home-scroll {
  height: 100vh;
  overflow-y: auto;
  padding-bottom: calc(76px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}
.home-top {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  background: #201c1d;
  border-bottom: 1px solid #302723;
  box-sizing: border-box;
}
.home-top .logo { position: static; width: 32px; height: 32px; margin: 0; padding: 0; object-fit: contain; transform: none; }
.service {
  width: 28px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border: 0;
  background: transparent;
  padding: 0;
}
.service img { width: 16px; height: 18px; object-fit: contain; }
.hero-swipe {
  margin: 12px 12px 0;
  overflow: hidden;
  border-radius: 8px;
  background: #292728;
}
.hero-swipe img { display: block; width: 100%; aspect-ratio: 2.3; object-fit: cover; }
.notice-card,
.quick-actions,
.popular-city-card {
  margin: 8px 8px 0;
  border: 1px solid var(--line);
  border-radius: 9px;
  background: linear-gradient(110deg, #232323, #303030);
  box-sizing: border-box;
}
.notice-card { min-height: 36px; display: flex; align-items: center; padding: 0 9px; gap: 10px; }
.notice-icon { width: 17px; height: 17px; object-fit: contain; flex-shrink: 0; }
.notice-text { min-width: 0; flex: 1; font-size: 12px; line-height: 18px; overflow: hidden; }
.notice-text marquee { display: block; }
.more-link { flex-shrink: 0; color: var(--muted); font-size: 12px; line-height: 20px; }
.quick-actions { margin-top: 11px; padding: 13px 4px 10px; display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); }
.quick-action {
  min-width: 0;
  min-height: 60px;
  padding: 0 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 0;
  background: transparent;
  color: var(--accent);
}
.quick-action img { width: 32px; height: 32px; object-fit: contain; }
.quick-action-label { width: 100%; font-size: 12px; line-height: 16px; overflow-wrap: anywhere; text-align: center; }
.popular-city-card { padding: 12px 8px 5px; }
.popular-city-label,
.section-title h2 { margin: 0; font-size: 14px; line-height: 20px; }
.popular-city-label::before,
.section-title h2::before { content: ''; display: inline-block; width: 3px; height: 12px; margin-right: 5px; background: var(--accent); vertical-align: -1px; }
.popular-city-grid { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); column-gap: 8px; row-gap: 9px; margin: 10px 8px 9px 18px; }
.popular-city-item { min-width: 0; color: var(--text); font-size: 12px; line-height: 20px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.popular-city-more { display: table; max-width: 100%; margin: 0 auto; padding: 2px 9px; border: 1px solid var(--line); border-radius: 4px; background: linear-gradient(120deg, #f5cfa8, #dbab73); color: #5a4839; font-size: 12px; line-height: 18px; box-sizing: border-box; text-align: center; overflow-wrap: anywhere; }
.girls-list-wrap { padding: 8px 10px 0; }
.section-title { min-height: 30px; padding: 5px 8px; margin: 0 -1px 24px; display: flex; align-items: center; justify-content: space-between; gap: 10px; background: #292828; box-sizing: border-box; }
.section-title h2 { min-width: 0; font-weight: 400; overflow-wrap: anywhere; }
.girls-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 15px 13px; }
.girl-card { min-width: 0; display: block; overflow: hidden; border: 4px solid var(--line); border-radius: 9px; background: #302c29; color: var(--text); box-sizing: border-box; }
.girl-media { position: relative; width: 100%; aspect-ratio: 0.84; overflow: hidden; }
.girl-photo { width: 100%; height: 100%; display: block; object-fit: cover; object-position: center top; }
.card-mark { position: absolute; top: 10px; left: 8px; width: 15px; height: 16px; object-fit: contain; }
.corner-ribbon { position: absolute; top: 12px; right: -27px; width: 100px; height: 22px; background: #f3c99e; color: #211d1a; text-align: center; transform: rotate(45deg); }
.corner-ribbon i { display: block; padding: 0 18px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 10px; line-height: 22px; font-style: normal; }
.girl-info { position: absolute; right: 0; bottom: 0; left: 0; padding: 5px 7px 6px; background: rgba(47, 44, 43, 0.58); }
.girl-topline { display: flex; align-items: center; justify-content: space-between; gap: 5px; }
.girl-topline h3 { min-width: 0; flex: 1; margin: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 14px; line-height: 20px; font-weight: 700; }
.location-chip { max-width: 48%; padding: 2px 9px; border-radius: 8px; background: linear-gradient(120deg, #f5cfa8, #dbab73); color: #5a4839; font-size: 10px; line-height: 15px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; box-sizing: border-box; }
.girl-metrics { display: flex; align-items: center; gap: 10px; margin-top: 4px; min-width: 0; }
.view-row,
.like-row { display: flex; align-items: center; gap: 4px; min-width: 0; color: #dedbd8; font-size: 10px; line-height: 14px; }
.girl-score { color: #f3c99e; font-weight: 700; }
.view-row img,
.like-row img { width: 13px; height: 12px; object-fit: contain; }
.view-row span,
.like-row span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.empty-list { padding: 24px 0; text-align: center; color: var(--muted); font-size: 12px; }
.dialog-img { display: block; width: 100%; }
.popup { max-height: 60vh; padding: 22px; overflow-y: auto; color: #51463c; font-size: 14px; line-height: 20px; }
/deep/ .van-swipe__indicator { background-color: var(--accent); }
/deep/ .van-list__loading,
/deep/ .van-list__finished-text,
/deep/ .van-list__error-text { color: var(--muted); }
@media screen and (max-width: 374px) {
  .girls-grid { gap: 12px 10px; }
  .girl-info { padding-right: 5px; padding-left: 5px; }
  .girl-topline h3 { font-size: 12px; }
  .location-chip { padding-right: 6px; padding-left: 6px; }
  .popular-city-grid { column-gap: 5px; margin-left: 8px; margin-right: 0; }
}
</style>
